import React, { Component } from 'react'

export default function(WrappedComponent, title) {
  return class extends Component {
    UNSAFE_componentWillMount() {
      document.title = title
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/HOC/Title.js